import { PMSmallStatus } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { getStreetlightStatusValue } from "../../../utils/dropdown-options";
import { DashboardCardContext } from "../context";
import { statusReportingLevel } from "../status-reporting-level";

/**
 * Accumulation of statuses — shows the count of each semaphore status
 * when status is reported per category.
 *
 * This is a separate component from the main status card and is only visible
 * when statusReportingLevel is "category".
 */
export function addAccumulationOfStatusesCard(ctx: DashboardCardContext) {
  const { view } = ctx;

  const accumulationOfStatusesComponent = view.addComponent({
    component: PMSmallStatus,
    layoutProps: {
      componentId: "accumulationOfStatusesComponent",
      title: "",
      description: "",
      labels: ["#ofStatuses"],
    },
  });

  accumulationOfStatusesComponent.mapLayoutProps(({ language }) => ({
    componentId: "accumulationOfStatusesComponent",
    labels: ["#ofStatuses"],
    description: getLocalizedMessage(language || "en", "showsNumberOfX", {
      x: getLocalizedMessage(language, "statuses"),
    }),
    title: getLocalizedMessage(language, "status"),
  }));

  accumulationOfStatusesComponent.mapState(
    ({ language, dashboard, settings }) => {
      const overallSemaphoreStatus =
        dashboard?._calculated?.overallSemaphoreStatus;
      const semaphoreStatus1 = dashboard?._calculated?.semaphoreStatus1;
      const semaphoreStatus2 = dashboard?._calculated?.semaphoreStatus2;
      const semaphoreStatus3 = dashboard?._calculated?.semaphoreStatus3;
      return {
        title: getLocalizedMessage(language, "status") || "Status",
        primaryStatusIndicatorSize: "large",
        fixedHeight: "134px",
        subStatusesDisplay: "column",
        status: getStreetlightStatusValue(overallSemaphoreStatus) ?? "",
        subStatuses:
          statusReportingLevel(settings) === "category"
            ? [semaphoreStatus1, semaphoreStatus2, semaphoreStatus3].map(
                (status, index) => ({
                  name:
                    settings?.configuration?.semaphoreStatusDefinition?.[index]
                      ?.name ?? "",
                  status: getStreetlightStatusValue(status) ?? "",
                })
              )
            : [],
      };
    }
  );

  accumulationOfStatusesComponent.mapVisibility(({ settings }) => {
    const isStatusEnabled =
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "itemReporting")
        .find((field) => field.fieldName === "status")?.enabled === true;
    return (
      isStatusEnabled &&
      (statusReportingLevel(settings) ?? "overall") === "category"
    );
  });
}
